import React from 'react'
import { css } from '@linaria/core'
import { Link } from '@fs/zion-router'
import { Paragraph, H3 } from '@fs/zion-ui'

const activityCss = css`
  display: flex;
  align-items: center;
`

const imageCss = css`
  height: 64px;
  width: 64px;
  min-width: 64px;
  border-radius: 64px;
  overflow: hidden;
  margin-right: 16px;
`

const textBlockCss = css`
  & h6 {
    padding: 0;
    line-height: 1em;
  }
  & p {
    padding-bottom: 0;
  }
`

export default function Activity({ heading, description, children, imageSrc, to, linkName }) {
  return (
    <Link noLinkStyles to={to} linkName={`Activities: ${linkName}`} external data-testid="activity-link">
      <div className={activityCss}>
        <div className={imageCss}>
          <img src={imageSrc} aria-hidden alt="" />
        </div>
        <div className={textBlockCss}>
          <H3 size="H5">{heading}</H3>
          <Paragraph size="sm">{description}</Paragraph>
          {children}
        </div>
      </div>
    </Link>
  )
}
